





















































import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import {NumberWings} from "wings-ui-components";

@Component({components: {NumberWings}})
export default class proxySettingsForm extends Vue {
  @Prop() value!: any;
  @Ref('validator') validator: any;

}

